<template>
  <v-snackbar v-model="snackbar" :left="true" :color="type">
    {{ message }}
    <v-btn flat @click="snackbar = false">Fermer</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  props: ['type', 'message', 'id'],
  data: () => ({
    snackbar: false
  }),
  watch: {
    id: function() {
      this.snackbar = true;
    }
  }
};
</script>